import React, { useState } from 'react';
import { X, Send } from 'lucide-react';

const LaunchComposerModal = ({ service, waitingCount, onCancel, onSend }) => {
  const [subject, setSubject] = useState(`${service} is now available at Aurelia`);
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      await onSend({ subject: subject.trim(), message: message.trim() });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4" data-testid="launch-composer-modal">
      <div className="fixed inset-0 bg-black/50" onClick={busy ? undefined : onCancel} />
      <div className="relative bg-white w-full max-w-2xl shadow-2xl border border-black/5">
        <div className="px-6 py-5 border-b border-black/10 flex items-center justify-between">
          <div>
            <p className="text-[10px] tracking-[0.28em] text-[#c9a961] font-semibold">SEND LAUNCH ANNOUNCEMENT</p>
            <h3
              className="font-serif text-2xl text-[#1c1e20] mt-1"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
            >
              {service}
            </h3>
            <p className="text-[13px] text-[#6b6b6b] mt-1">
              {waitingCount} {waitingCount === 1 ? 'person' : 'people'} on the waiting list will receive this email.
            </p>
          </div>
          <button
            onClick={onCancel}
            disabled={busy}
            className="text-[#6b6b6b] hover:text-[#1c1e20] disabled:opacity-40"
            aria-label="Close"
            data-testid="launch-composer-close"
          >
            <X size={22} />
          </button>
        </div>

        <div className="px-6 py-5 space-y-4">
          <div>
            <label className="block text-[10px] tracking-[0.28em] text-[#6b6b6b] font-semibold mb-2">
              SUBJECT
            </label>
            <input
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              data-testid="launch-subject-input"
              className="w-full border border-black/15 px-4 py-3 text-[14px] focus:outline-none focus:border-[#c9a961]"
            />
          </div>
          <div>
            <label className="block text-[10px] tracking-[0.28em] text-[#6b6b6b] font-semibold mb-2">
              LAUNCH MESSAGE (OPTIONAL)
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={6}
              placeholder={`Optional. If left blank, we\u2019ll send a polished default announcement inviting them to book ${service}. Add anything you want (launch pricing, a personal note, a specific booking window, etc.)`}
              data-testid="launch-message-input"
              className="w-full border border-black/15 px-4 py-3 text-[14px] focus:outline-none focus:border-[#c9a961] resize-none"
            />
            <p className="text-[11px] text-[#6b6b6b] mt-2">
              Each recipient will see this over the Aurelia branded header, with a personal greeting and a BOOK YOUR APPOINTMENT button below.
            </p>
          </div>
        </div>

        <div className="px-6 py-4 border-t border-black/10 flex items-center justify-end gap-3 bg-[#faf6f0]">
          <button
            onClick={onCancel}
            disabled={busy}
            data-testid="launch-cancel"
            className="border border-black/15 hover:border-[#c9a961] text-[#1c1e20] px-5 py-2.5 text-[11px] tracking-[0.22em] font-semibold disabled:opacity-40"
          >
            CANCEL
          </button>
          <button
            onClick={send}
            disabled={busy || !subject.trim() || waitingCount === 0}
            data-testid="launch-send"
            className="flex items-center gap-2 bg-[#c9a961] hover:bg-[#b89751] text-[#141618] px-5 py-2.5 text-[11px] tracking-[0.22em] font-semibold disabled:opacity-60"
          >
            <Send size={13} /> {busy ? 'SENDING\u2026' : `SEND TO ${waitingCount}`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LaunchComposerModal;
